export default __webpack_public_path__ + "static/media/banner-6.fea88e9a.jpg";